import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { FarmService } from 'src/app/services/farm-service.service';
import { PhameeService } from 'src/app/services/phamee.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'smart-weather-forecast',
  templateUrl: './weather-forecast.component.html',
  styleUrls: ['./weather-forecast.component.scss','../../platform-color/platform-color.css']
})
export class WeatherForecastComponent implements OnInit {
  form: FormGroup;

  farmList = [];
  farmInfo: any = null;
  farmId: string = "";
  dailyUrl: string = environment.THAICOM_URL +  "embed/weather_daily?language=th";
  hourlyUrl: string  = environment.THAICOM_URL +  "embed/weather_hourly?language=th";

  dailyUrlFilter: SafeResourceUrl;
  hourlyUrlFilter: SafeResourceUrl;
  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private phameeService: PhameeService,
    private farmService: FarmService,
    private sanitizer: DomSanitizer
  ) { 
    this.createForm();
    this.farmId = sessionStorage.getItem("farmId");
  }

  ngOnInit(): void {
    this.getFarm();
  }

  createForm(){
    this.form = this.formBuilder.group({
      farm: [""],
    })
  }

  async getFarm(){
    this.spinner.show();

    this.phameeService.getDropdownDashboard()
    .subscribe(success => {
 
      this.farmList = success.data.FarmList || [];
      if(this.farmId){
        this.form.controls.farm.setValue(this.farmId);

        this.getWeather(this.farmId);
      }else if(this.farmList.length > 0){
        this.form.controls.farm.setValue(this.farmList[0]._id);

        this.getWeather(this.farmList[0]._id);
      }
    });
  }

  getWeather(farm_id){
    this.spinner.show();
    let name = this.farmList.find(farm=> farm._id == farm_id).name;

    if(name){
      this.farmService.getFarmByName(name).subscribe(success => {
        if (success.code == 200) {
          this.farmInfo = success.data[0];
          this.dailyUrlFilter = this.sanitizer.bypassSecurityTrustResourceUrl(this.dailyUrl + "&location=" + this.farmInfo.coordinates['center'].lat+","+this.farmInfo.coordinates['center'].lon);
          this.hourlyUrlFilter = this.sanitizer.bypassSecurityTrustResourceUrl(this.hourlyUrl + "&location=" + this.farmInfo.coordinates['center'].lat+","+this.farmInfo.coordinates['center'].lon);
          this.spinner.hide();
        }
      });
    }
  }
}
